if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.productTemporaryData = [];
      this.ecoPackSellingPlans = {};
      this.subscriptionCartAmountNewState = 0;
      this.cartNotification = document.querySelector('cart-notification');
    }

    /* 2026-10-26: Add-to-Cart ohne AMP Slide Cart. Vorher hat AMP den Submit abgefangen und das Formular
       1:1 in den Warenkorb gelegt; dieser Handler lief deshalb nie. Die alte Eco-Pack-Logik (alle Refills
       aus dem Warenkorb nehmen und mit neu zugewiesenen Abo-Plaenen wieder hinzufuegen) ist entfernt.
       Jetzt: Formular unveraendert per /cart/add.js hinzufuegen (wie AMP), danach Custom Side Cart oeffnen. */
    openCart() {
      try {
        if (window.CSC_CART && typeof window.CSC_CART.open === 'function') {
          window.CSC_CART.open();
          if (typeof window.CSC_CART.refresh === 'function') window.CSC_CART.refresh();
          return;
        }
      } catch (e) {}
      try {
        if (typeof window.SLIDECART_OPEN === 'function') { window.SLIDECART_OPEN(); return; }
      } catch (e) {}
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton && submitButton.classList.contains('loading')) return;
      const spinner = this.querySelector('.loading-overlay__spinner');

      this.handleErrorMessage();
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData(this.form);
      if (formData.has('selling_plan') && !formData.get('selling_plan')) formData.delete('selling_plan');
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
        .then(({ ok, json }) => {
          if (!ok || json.status) {
            this.handleErrorMessage((json && (json.description || json.message)) || 'Das hat nicht geklappt. Bitte versuche es erneut.');
            return;
          }
          this.openCart();
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('Das hat nicht geklappt. Bitte versuche es erneut.');
        })
        .finally(() => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


window.addEventListener('load', () => {
  const subscriptionCheckbox = document.querySelectorAll('.rc-radio');
  if (!Array.isArray(subscriptionCheckbox) && !subscriptionCheckbox.length) return;

  const membershipCheckbox = document.querySelector('.subscription-radio');
  const productPrice = document.querySelector('.price-item');
  const discountPrice = document.querySelector('.rc-radio__price');
  const discountPriceTag = document.createElement('span');

  discountPriceTag.innerText = discountPrice.innerText;
  productPrice.style.textDecoration = 'line-through';
  discountPriceTag.style.marginRight = '10px';

  productPrice.insertAdjacentElement('beforebegin', discountPriceTag);

  for (const checkbox of subscriptionCheckbox) {
    checkbox.addEventListener('change', () => {
      if (!membershipCheckbox.classList.contains('rc-radio--active')) {
        discountPriceTag.style.display = 'none';
        productPrice.style.textDecoration = 'none';
      } else {
        discountPriceTag.style.marginRight = '10px';
        discountPriceTag.style.display = 'block';
        productPrice.style.textDecoration = 'line-through';
      };
    });
  };
})
